import API from '@cloudpivot-shared/domain-api';
// eslint-disable-next-line import/extensions
import api from './api.mappings';

import * as dingtalk from './dingtalk-params';

export class DingTalkApi {
  sign (params: dingtalk.SignParams) {
    return API.Global.request({
      url: api.dingTalk.sign,
      method: 'get',
      params
    });
  }

  login (params: dingtalk.LoginParams) {
    return API.Global.request({
      url: api.dingTalk.login,
      method: 'get',
      params
    });
  }

  getLoginInfo () {
    return API.Global.request({
      url: api.user.getLoginInfo,
      method: 'get'
    });
  }
}

export const dingTalkApi = new DingTalkApi();
